/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model', 'GatewayApi'];
const factory = function (Model, GatewayApi) {
  class ConversationSummary extends Model {
    static initClass() {
      this.prototype.id = null;
      this.prototype.$apiService = GatewayApi;
    }

    $init() {}
    $fetch() {}
    $put() {}
    $delete() {}
    $post() {}
  }
  ConversationSummary.initClass();

  return ConversationSummary;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.conversationSummary', moduleDeps)
  .factory('ConversationSummary', factory);
